// Stat display tile for the admin dashboard. Extracted verbatim from
// the inline `KpiTile` function previously inside AdminDashboard.jsx (W2d).
// Same DOM, same test-id contract, same inline styles.
export default function KpiTile({ label, value, sub, testid }) {
  return (
    <div className="sf-card-inset" style={{ minHeight: 96 }} data-testid={testid}>
      <div className="sf-eyebrow" style={{ marginBottom: 6 }}>{label}</div>
      <div className="sf-score-number" style={{ fontSize: 30 }}>{value}</div>
      {sub && <div className="sf-mono sf-muted-text" style={{ marginTop: 4, fontSize: 11 }}>{sub}</div>}
    </div>
  );
}
